var map = {
	"./Catsup.png": 7616,
	"./CatsupRefill.png": 251,
	"./ChilliPepper.png": 8043,
	"./Chipotle.png": 3377,
	"./Harina.png": 3485,
	"./Jalapeno.png": 2842,
	"./Jamon.png": 2891,
	"./Notfound.png": 9898,
	"./Oil.png": 2288,
	"./Onion.png": 7432,
	"./Pasta.png": 1011,
	"./Peperoni.png": 3319,
	"./Pineapple.png": 8193,
	"./PizzaBox.png": 8770,
	"./Queso.png": 1205,
	"./Refresco.png": 5259,
	"./Salchicha.png": 9489,
	"./SalchichaItaliana.png": 1042,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./wrocco logo.jpg": 4236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;